import { BaseFetch } from "../main-model"
export default class ScheduleTimeModel extends BaseFetch {
    getScheduleTimeBy = (data) =>
    this.authFetch({
      url: "schedule-time/getScheduleTimeBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getScheduleTimeById = (data) =>
    this.authFetch({
      url: "schedule-time/getScheduleTimeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertScheduleTime = (data) =>
    this.authFetch({
      url: "schedule-time/insertScheduleTime",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateScheduleTimeById = (data) =>
    this.authFetch({
      url: "schedule-time/updateScheduleTimeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteScheduleTimeById = (data) =>
    this.authFetch({
      url: "schedule-time/deleteScheduleTimeById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
